import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import { setBadge } from 'modules/common/utils';
import { colors, dimensions } from 'modules/common/styles';
import { Tip, Label } from 'modules/common/components';
import { localStore } from 'helpers';
import { withRouter } from 'react-router';
import { globalStateSelector } from 'store/selector';
import { connect } from 'react-redux';
import { agentAccess, otherUser, superAdminAccess } from '../../../../../helpers/system-config';
import { companyMenuIcon } from '../../../../../helpers/dotenv';
import { TiThMenu } from 'react-icons/ti';
// import { companyMenuIcon } from 'helpers/dotenv';


const LeftNavigation = styled.aside`
  width: ${dimensions.headerSpacingWide}px;
  background: ${colors.colorWhite};
  z-index: 6000;
  flex-shrink: 0;
  overflow: visible;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  @media (max-width: 760px)
  {
    background:none;
  }
  // span {
  //   position: absolute;
  //   right: 12px;
  //   top:5;
  //   // bottom: 12px;
  //   // margin-top: -10px;
  //   padding: 4px;
  //   min-width: 19px;
  //   min-height: 19px;
  // }
  > a {
    display: flex;
    margin-top: ${dimensions.unitSpacing}px;
    height: ${dimensions.headerSpacing}px;
    justify-content: center;
    align-items: center;

    img {
      // width: 28px;
      @media (max-width: 760px)
      {
        margin-left: 32px
      }
      
      max-height: 28px;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }
  }
`;

const Nav = styled.nav`
  display: block;
  // margin-top: ${dimensions.unitSpacing}px;
  height: calc(100% - 70px);
  // overflow: scroll;
  text-align: center;

  > a {
    display: block;
    height: ${dimensions.headerSpacing + 10}px;
    text-align: center;
    position: relative;
    transition: all 0.3s ease;

    &:hover {
      background-color: #D6EAF8;
    }
    i {
      // opacity: 0.8;
      transition: all 0.3s ease;
    }

    &.active {
      // background: rgba(0, 0, 0, 0.13);

      // &:before {
      //   content: '';
      //   width: 8px;
      //   height:8px;
      //   background: ${colors.colorCoreTeal};
      //   position: absolute;
      //   display: block;
      //   right: 0;
      //   top: 27px;
      //   bottom: 0;
      //   border-radius: 50px;
      // }
      &:before {
        content: '';
        width: 4px;
        height: 90%;
        // background: ${colors.colorCoreTeal};
        background: ${colors.themeBlue};
        position: absolute;
        display: block;
        right: 0;
        // top: 27px;
        bottom: 0;
        border-radius: 20px;
      }

      i {
        opacity: 1;
      }
    }

    &:focus {
      outline: 0;
    }

    &:hover {
      // background: rgba(0, 0, 0, 0.05);

      i {
        opacity: 1;
      }
    }

    @media (max-height: 760px) {
      // height: ${dimensions.headerSpacing}px;

      i {
        line-height: 58px;
      }
    }
  }

  &::-webkit-scrollbar {
    display: none;
  }
`;


const NavIcon = styled.div`
  // font-size: 16px;
  line-height: ${dimensions.headerSpacing-8}px;
  // color: #00000;
  img {
    // width: 28px;
    width: 40px;
  }
`;

const NavText = styled.p`
  font-size: 10px;
  line-height: 11px;
  // color: #808080;
  color: #000;
  // margin-top: -1px;
  font-weight: 600;
`;

const Logo = styled.div`
  img {
    position: fixed;
    margin-top: -22px;
    margin-left: -25px;
  }
`;

const NavbarDropdownContent = styled.div`
  display: none;
  position: absolute;
  top: 0;
  left: 100%;
  // margin-top: 18px;
  // margin-left: 22px;
  // background-color: white;
  background-color: #e7f3fb;
  min-width: 160px;
  // padding: 2px 5px;
  color: black;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.1);
  z-index: 99999;
  &:hover {
    // color: black;
    cursor: pointer;
  }
  > a {
    &.active {
    background-color: #D6EAF8;;

    }
  }
`;

const NavbarDropdown = styled.div`
  position: relative;
  display: block;
  // text-align: center;
  color: #808080;
  &:hover {
    background-color: #D6EAF8;
  }
  &:hover ${NavbarDropdownContent} {
    display: block;
  }

  > a {
    &.active {
      // background: rgba(0, 0, 0, 0.13);
      // & {
      //   background-color: #D6EAF8;
      // }
      &:before {
        content: '';
        width: 4px;
        height: 90%;
        // background: ${colors.colorCoreTeal};
        background: ${colors.themeBlue};
        position: absolute;
        display: block;
        right: 0;
        // top: 27px;
        bottom: 0;
        border-radius: 20px;
      }

      i {
        opacity: 1;
      }
    }
  }

`;

const submenuStyle = {
  padding: "12px 15px",
  // marginLeft: "5px",
  textAlign: "left",
  // color: "#808080 !important",
  // backgroundColor: "#808080",
}

const navlinkStyle = {
  color: "#36454F"
  // color:"black"
}

// mobile view

const NavMob = styled.nav`
  display: block;
  width: ${dimensions.headerSpacingWide}px;
  background: ${colors.colorWhite};
  // height: calc(100% - 80px);
  height: 100%;
  z-index: 6000;
  flex-shrink: 0;
  overflow: visible;
  text-align: center;
  padding-top: 40px;
  // position: fixed;
  // left: 0;
  // top: 0;
  // bottom: 0;
  > a {
    display: block;
    margin-top: ${dimensions.unitSpacing}px;
    height: ${dimensions.headerSpacing}px;
    justify-content: center;
    align-items: center;

    img {
      max-height: 28px;
      transition: all 0.3s ease;

      &:hover {
        transform: scale(1.1);
      }
    }
  } 
`;
const Mobilenavicon = styled.div`
  display: none;
 @media(max-width: 760px)
 {
  height: 100%;
  display: block;

 }
 
  
`;
const Menuicon = styled.div`
 margin-left: 25px;
 margin-top: -43px;
 height: 0%;

`;

class Navigation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navbar: false,
      _id: '',
      name: ''
    };
  }

  componentDidUpdate() {
    const { __ } = this.context;
    setBadge(this.props.unreadConversationsCount, __('Inbox'));
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.unreadConversationsCount > this.props.unreadConversationsCount
    ) {
      // const audio = new Audio('/sound/notify.mp3');
      // audio.play();
    }
  }

  getLocationCheck( path ) {
    try {
      return window.location.pathname == path ? true : false
    } catch (error) {
      return false;
    }
  }
  render() {
    const basename = process.env.BASE_PATH_PREFIX || "";
    let { currentUser } = this.props;
    const { __ } = this.context;
    currentUser = currentUser || {};
    let agentRole = currentUser && parseInt(currentUser.role) || '';
    
    console.log('Current User', agentAccess);
    console.log('props.location', this.props);

    return (
      <LeftNavigation>
        <NavLink to="/">
          <Logo>
            {/* <img src="/images/SS_LOGO.png" alt="stream" /> */}
            <img src={`/images/${companyMenuIcon}`} alt="logo" className='logo' />
          </Logo>
        </NavLink>
        <span>
          <Mobilenavicon>
            <Menuicon>
            <TiThMenu
              onClick={() => {
                this.state.navbar ? this.setState({ navbar: false }) : this.setState({ navbar: true })

                console.log('navbar', this.state.navbar);
              }}
            ></TiThMenu>
            </Menuicon>
          

          {this.state.navbar ? <NavMob>

            {agentAccess.includes(agentRole) &&
              <React.Fragment>
                  <NavbarDropdown>
                    <NavLink to="/dashboard" activeClassName="active">
                      <NavIcon>
                        <img src={`${basename}/images/nav/newTheme/Dashboard.svg`} alt="message"></img>
                      </NavIcon>
                      <NavText>Dashboard</NavText>
                    </NavLink>
                  </NavbarDropdown>
                  <NavbarDropdown>
                    <NavLink to="/campaign" activeClassName="active">
                      <NavIcon>
                        <img src={`${basename}/images/nav/newTheme/Campaign.svg`} alt="message"></img>
                      </NavIcon>
                      <NavText>Campaign</NavText>
                    </NavLink>
                  </NavbarDropdown>
                  <NavbarDropdown>
                    <NavLink to="/analytics" activeClassName="active">
                      <NavIcon>
                        <img src={`${basename}/images/nav/newTheme/Analytics.svg`} alt="message"></img>
                      </NavIcon>
                      <NavText>Analytics</NavText>
                    </NavLink>
                  </NavbarDropdown>
              </React.Fragment>
            }
           
          </NavMob> : ''}

          </Mobilenavicon>

          <Nav>

            {agentAccess.includes(agentRole) &&
              <React.Fragment>
                <NavbarDropdown>
                    <NavLink to="/dashboard" activeClassName="active">
                      <NavIcon>
                        <img src={`${basename}/images/nav/newTheme/Dashboard.svg`} alt="message"></img>
                      </NavIcon>
                      <NavText>Dashboard</NavText>
                    </NavLink>
                  </NavbarDropdown>
                  <NavbarDropdown>
                    <NavLink to="/campaign" activeClassName="active">
                      <NavIcon>
                        <img src={`${basename}/images/nav/newTheme/Campaign.svg`} alt="message"></img>
                      </NavIcon>
                      <NavText>Campaign</NavText>
                    </NavLink>
                  </NavbarDropdown>
                  <NavbarDropdown>
                    <NavLink to="/analytics" activeClassName="active">
                      <NavIcon>
                        <img src={`${basename}/images/nav/newTheme/Analytics.svg`} alt="message"></img>
                      </NavIcon>
                      <NavText>Analytics</NavText>
                    </NavLink>
                  </NavbarDropdown>
              </React.Fragment>
            
            }
          </Nav>
        </span>
      </LeftNavigation>
    );
  }
}

Navigation.propTypes = {
  unreadConversationsCount: PropTypes.number
};

Navigation.contextTypes = {
  __: PropTypes.func,
  currentUser: PropTypes.object
};

const stateToProps = state => ({
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' })
});

const dispatchToProps = dispatch => ({
  dynamicUpdate: data => {
    // dispatch(globalAction.dynamicUpdate({ data }));
  }
});

export default connect(stateToProps, dispatchToProps)(Navigation);



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/layout/components/Navigation.js